import { Component } from "react";
import * as Sentry from "@sentry/react";

/**
 * App-wide error boundary. A single thrown render error used to blank the
 * entire app (a white screen). This catches it, keeps a usable shell, and
 * offers a reload. The full error and component stack go to the console so
 * the real cause is never hidden.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[Klareet] render error caught by boundary:", error, info && info.componentStack);
    // Report to Sentry when configured; a no-op otherwise.
    Sentry.captureException(error, {
      contexts: { react: { componentStack: info && info.componentStack } },
    });
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "2rem", background: "#FAF9F7", color: "#1A202C", fontFamily: "system-ui, -apple-system, sans-serif" }}>
        <div style={{ maxWidth: "26rem", textAlign: "center" }}>
          <h1 style={{ fontSize: "1.4rem", margin: "0 0 0.5rem" }}>Something went wrong</h1>
          <p style={{ opacity: 0.75, lineHeight: 1.55, margin: "0 0 1.25rem" }}>
            The page hit an unexpected error. Your data is safe. Reloading usually clears it.
          </p>
          <button
            type="button"
            onClick={() => { window.location.href = "/"; }}
            style={{ padding: "0.6rem 1.2rem", borderRadius: "0.6rem", border: "none", background: "#1A202C", color: "#fff", fontWeight: 600, cursor: "pointer" }}
          >
            Reload Klareet
          </button>
        </div>
      </div>
    );
  }
}
